import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from '@pelckmans/elementis/components/toast';
import Button from '@pelckmans/elementis/components/button';
import AddLicenseModal from '../../../../../shared-components/AddLicenseModal';
import ModalContext from '../../../../../contexts/ModalContext';
import ModuleContext from '../../../_contexts/ModuleContext';

const BASE = 'PAGES.TOC_LEVEL.SECTIONS.TEACHER.MATERIAL';

interface UseWithLicenseCheckProps {
  id: number;
}

export function useWithLicenseCheck({ id }: UseWithLicenseCheckProps) {
  const { t } = useTranslation();
  const { showModal } = useContext(ModalContext);
  const { addToast, removeToast } = useToast();
  const { selectedModule, refetch: refetchModule } = useContext(ModuleContext);

  const hasDocumentLicenseForTeacher = selectedModule?.licenses.hasDocumentLicenseForTeacher;

  return {
    hasLicense: hasDocumentLicenseForTeacher,
    licenseCheck: (callback?: () => void) => () => {
      if (!hasDocumentLicenseForTeacher) {
        addToast({
          id,
          variant: 'warning',
          title: t(`${BASE}.TOAST.NO_LICENSE.TITLE`),
          children: t(`${BASE}.TOAST.NO_LICENSE.TEXT`),
          actions: {
            role: undefined,
            'aria-label': undefined,
            children: (
              <Button
                prominence="warning"
                onClick={() => {
                  showModal(
                    <AddLicenseModal
                      id="add-license-modal"
                      onRefetch={() => {
                        refetchModule();
                      }}
                    />,
                  );
                  removeToast(id);
                }}
              >
                {t(`${BASE}.TOAST.NO_LICENSE.ACTIONS.BUTTON.TEXT`)}
              </Button>
            ),
          },
          loadingAriaLabel: t(`${BASE}.TOAST.NO_LICENSE.LOADING_ARIA_LABEL`),
          allowDuplicate: false,
        });

        return;
      }

      if (callback) callback();
    },
  };
}
